<template>
  <div class="d-flex membership_user_search_width" v-if="is_load">
    <v-container class="col-11 ml-0 mt-10 pl-0 pb-7">
      <v-row class="mb-4 ml-0 height50px" cols="12">
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          가입일
        </v-col>
        <v-col cols="4">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.join_from"
                readonly
                v-on="on"
                dense
                style="width: 110px; height: 50px;"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.join_from"
              @input="startMenu = false"
              locale="ko"
              :max="searchPayload.join_to"
            ></v-date-picker> </v-menu
          >~
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.join_to"
                readonly
                v-on="on"
                dense
                style="width: 110px; height: 50px;"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.join_to"
              @input="endMenu = false"
              locale="ko"
              :min="searchPayload.join_from"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="2" class="pb-0 pt-5 pl-0">
          가입한 멤버십
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="searchPayload.membership_id"
            :items="joinMembershipItems"
            item-text="text"
            item-value="value"
            outlined
            dense
            class="mr-1"
            :style="{ width: '94%' }"
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" class="pb-0 pt-5 pl-0 height50px">회원 ID</v-col>
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            hide-details
            class="mr-1"
            placeholder="아이디 입력"
            v-model="searchPayload.member_id"
            :style="{ width: '86%' }"
            v-on:keyup.enter="searchMember()"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          멤버십 상태
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="searchPayload.member_membership_status"
            :items="membershipStatusItems"
            outlined
            dense
            hide-details
            class="mr-1"
            :style="{ width: '94%' }"
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" class="pb-0 pt-5 pl-0 height50px">회원이름</v-col>
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            class="mr-1"
            placeholder="회원이름 입력"
            v-model="searchPayload.member_name"
            :style="{ width: '86%' }"
            v-on:keyup.enter="searchMember()"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          휴대전화
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="searchPayload.member_phone"
            outlined
            dense
            class="mr-1"
            placeholder="휴대전화 입력"
            :style="{ width: '94%' }"
            v-on:keyup.enter="searchMember()"
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="row justify-center mb-10">
        <v-btn
          large
          color="grey darken-4"
          class="white--text"
          width="100"
          @click="searchMember()"
          >조회</v-btn
        >
        <v-btn
          large
          style="margin-left: 20px;"
          width="100"
          @click.prevent="resetSearch"
          >초기화</v-btn
        >
      </div>
    </v-container>
    <ProgressDialog ref="ProgressDialog"></ProgressDialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Common from "@/libs/common.js";
const ProgressDialog = () =>
  import(
    /* webpackChunkName: "ProgressDialog" */ "@/components/membership/membership_manage/modal/ProgressDialog.vue"
  );
export default {
  data() {
    return {
      modal: false,
      startMenu: false,
      endMenu: false,
      membership_id: { text: "멤버십 전체", value: "" },
      joinMembershipItems: [{ text: "멤버십 전체", value: "" }],
      searchPayload: {
        join_from: "",
        join_to: "",
        membership_id: "",
        member_id: "",
        member_membership_status: "",
        member_name: "",
        member_phone: "",
        limit: 50,
        offset: 0,
        page: 1,
      },
      total_count: 0,
      membershipStatusItems: [
        { text: "멤버십 전체", value: "" },
        { text: "가입중", value: "enabled" },
        { text: "만료", value: "disabled" },
        { text: "해지", value: "canceled" },
        { text: "가입중 (해지 예정)", value: "unsubscribe" }
      ],
      is_load: false,
      is_search_loading: false,
    };
  },
  methods: {
    searchMember: async function() {
      this.searchPayload.offset = 0;
      this.searchPayload.page = 1;
      this.$parent.$refs.UserMemberList.page = 1;
      await this.execSearch();
    },
    /**
     * 검색
     */
    execSearch: async function() {
      this.$refs.ProgressDialog.show();
      await this.getMemberList();
      setTimeout(() => {
        this.$refs.ProgressDialog.hide();
      }, 500);
    },
    getMemberList: async function() {
      this.searchPayload.join_from = Common.dateTypeFromat(
        this.searchPayload.join_from
      );
      this.searchPayload.join_to = Common.dateTypeFromat(
        this.searchPayload.join_to
      );
      try {
        let result = await M.api(
          M.entry("/get/membership/members"),
          this.searchPayload
        );

        // 만약 offset > 0 인데 결과가 0이면
        // offset을 0으로 주고 다시 조회한다.
        if (
          result.list.length == 0 &&
          result.count > 0 &&
          this.searchPayload.offset > 0
        ) {
          this.searchPayload.offset = 0;
          this.searchPayload.page = 1;
          this.$parent.$refs.UserMemberList.page = 1;
          result = await M.api(
            M.entry("/get/membership/members"),
            this.searchPayload
          );
        }

        this.total_count = result.count;
        this.searchPayload.page = 1;
        let pagein_count =
          Number(this.total_count) / Number(this.searchPayload.limit);
        this.$parent.$refs.UserMemberList.pageCount = Math.ceil(pagein_count);
        this.$parent.$refs.UserMemberList.setUserList(result);
      } catch (e) {
        alert("새로고침(F5)하여 재확인해주세요.");
      }
    },
    resetSearch: function() {
      let befor1Month = new Date();
      befor1Month.setMonth(befor1Month.getMonth() - 1);
      let toDay = new Date();

      this.searchPayload = {
        join_from: M.yyyymmdd(befor1Month),
        join_to: M.yyyymmdd(toDay),
        membership_id: "",
        member_id: "",
        member_membership_status: "",
        member_name: "",
        member_phone: "",
        limit: 50,
        offset: 0,
        page: 1,
      };

      this.execSearch();
    },
    setSearchPayload: async function(viewListCount, page) {
      this.searchPayload.limit = viewListCount;
      this.searchPayload.page = page;
      let offset =
        this.searchPayload.limit * this.searchPayload.page -
        this.searchPayload.limit;
      this.searchPayload.offset = offset;
      await this.execSearch();
    },
    getmembershipList: async function() {
      ///get/membership/list
      try {
        let result = await M.api(M.entry("/get/membership/list"));
        for (let i = 0; i < result.length; i++) {
          if (result[i].membership_status == "disbaled") {
            continue;
          }
          let setData = {
            text: result[i].membership_name,
            value: result[i].membership_id,
          };
          this.joinMembershipItems.push(setData);
        }
      } catch (e) {
        alert("새로고침(F5)하여 재확인해주세요.");
      }
    },
  },
  mixins: [CommonMixin],
  created: async function() {
    //await this.execSearch();
  },
  mounted: async function() {
    let befor1Month = new Date();
    befor1Month.setMonth(befor1Month.getMonth() - 1);
    let toDay = new Date();

    this.searchPayload.join_from = M.yyyymmdd(befor1Month);
    this.searchPayload.join_to = M.yyyymmdd(toDay);

    // await this.execSearch();
    await this.getmembershipList();
    this.$parent.progressHide();
    this.is_load = true;
    await this.$parent.serchShow();
  },
  components: {
    ProgressDialog,
  },
};
</script>
